import { render, staticRenderFns } from "./ViewMain.vue?vue&type=template&id=5c132c7d"
import script from "./ViewMain.vue?vue&type=script&lang=js"
export * from "./ViewMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports